<template>
  <a-layout class='index animated fadeIn'>
    <a-card :bordered='false'>
      <a-form ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-item ref="level" label="级别" name="level">
          <a-row :gutter="16">
            <a-col :span="16">
              <a-input v-model:value="form.level" placeholder='请输入级别' disabled />
            </a-col>
            <a-col :span="8">
              <p>系统自动按顺序分配</p>
            </a-col>
          </a-row>
        </a-form-item>
        <a-form-item ref="level_name" label="级别名称" name="level_name">
          <a-row :gutter="16">
            <a-col :span="16">
              <a-input v-model:value="form.level_name" placeholder='请输入级别名称'  maxlength="10" />
            </a-col>
            <a-col :span="8">
              <p>最多10个字</p>
            </a-col>
          </a-row>
        </a-form-item>
        <!-- <a-form-item ref="type_id" label="门店类型" name="type_id">
          <a-row :gutter="16">
            <a-col :span="16">
              <a-select v-model:value="form.type_id" placeholder="请选择经门店类型">
                <a-select-option v-for='item in typeList' :key='item.type_id' :value="item.type_id">{{item.type_name}}</a-select-option>
              </a-select>
            </a-col>
            <a-col :span="8">
              <a href="javascript:;" @click='typeSetup("type")'>门店类型设置</a>
            </a-col>
          </a-row>
        </a-form-item> -->
        
        <!-- <a-form-item required ref="" label="门店管理" name="">
          <a-row :gutter="16">
            <a-col :span="24">
              <a-radio-group v-model:value="form.manage">
                <a-radio :value="1">
                  允许
                </a-radio>
                <a-radio :value="0">
                  不允许
                </a-radio>
              </a-radio-group>
            </a-col>
            <a-col :span="20" v-if='form.manage == 1'>
              <a-checkbox v-model:checked="form.is_can_add">
                添加门店
              </a-checkbox>
              <a-checkbox v-model:checked="form.is_can_del">
                删除门店
              </a-checkbox>
            </a-col>
          </a-row>
        </a-form-item> -->
        <a-form-item ref="growth_value" label="需成长值达" name="growth_value">
          <a-row :gutter="16">
            <a-col :span="16">
              <a-input-number v-model:value="form.growth_value" placeholder='请输入成长值' :min="leveData.growth_value?leveData.growth_value:0" style="width:300px" :disabled="formData.is_default==1"/>
            </a-col>
            <a-col :span="8">
              <a href="javascript:;" @click='typeSetup("grow")'>成长值设置</a>
            </a-col>
          </a-row>
        </a-form-item>
        <a-form-item ref="remarks" label="备注" name="remarks" >
          <a-row :gutter="16">
            <a-col :span="16">
              <a-textarea v-model:value="form.remarks" showCount :maxlength="200" placeholder="请输入备注" :rows="4" />
            </a-col>
          </a-row>
        </a-form-item>
        <a-form-item :wrapper-col="{ span: 8, offset: 3 }">
          <a-button type="primary" @click="onSubmit">
            保存
          </a-button>
        </a-form-item>
      </a-form>
    </a-card>
  </a-layout>
</template>
<script>
  import { ref, onMounted, reactive, toRefs, inject,watchEffect } from 'vue';
  import { message } from 'ant-design-vue';
  import { getTypeList } from "@/api/store";
  import { iscode } from "@/utils/app";
  import {  setlevelAdd, levelEdit,getLevels } from "@/api/store";
  // 初始化默认筛选项数值
  let defForm = {
    level: '1',
    level_name: '',
    // type_id: undefined,
    // is_can_add: 0,
    // is_can_del:0,
    growth_value:'',
    remarks:'',
    // manage:0,
  }
  export default {
    name:'levelAdd',
    components: {},
    props: {
      formData: {
        type: Object
      },
      formType:{
        type:String
      }
    },
    setup(props,{emit}) {
      //pass
      const form = ref({ ...defForm });
      const state = reactive({
        leveData:{},
        typeList:[],
        labelCol: { span: 3 },
        wrapperCol: { span: 16 },
        rules: {
          // level: [
          //   { required: true, message: '请输入级别'}
          // ],
          level_name: [
            { required: true, message: '请输入级别名称'}
          ],
          // type_id: [
          //   { required: true, message: '请选择级别类型'}
          // ],
          growth_value:[
            {required: true, message: '请选输入所需成长值'}
          ],
        }
      });
      const ruleForm = ref()
      const _lodash = inject("_lodash");
      const typeSetup = (type) =>{
        emit("settype", type);
      }
      const getLevel = async() =>{
        let res = await getLevels().then(res => res.data);
        if (iscode(res)) {
          form.value.level=1
          if(res.data.level){
              state.leveData = res.data;
              form.value.level=parseInt(res.data.level)+1;
          }
        } else {
          message.error(res.msg);
        }
      }
      const onSubmit = () => {
        ruleForm.value.validate().then(async() => {
          let res
          const hide = message.loading('正在加载中...', 0);
          if (form.value.id) {
            res = await levelEdit({
              ...form.value,
              // is_can_add: form.value.is_can_add ? 1 : 0,
              // is_can_del: form.value.is_can_del ? 1 : 0
            }).then(res => res.data);
          } else {
            res = await setlevelAdd({
              ...form.value,
              // is_can_add: form.value.is_can_add ? 1 : 0,
              // is_can_del: form.value.is_can_del ? 1 : 0
            }).then(res => res.data);
          }
          if (iscode(res)) {
            setTimeout(hide);
            message.success(res.msg);
            emit('onsubmit')
            ruleForm.value.resetFields();
          } else {
            setTimeout(hide);
            message.error(res.msg);
          }
        }).catch(error => {
          message.error('请完善表单！');
        });
      }
      onMounted(() => {
        if(props.formType == 'add'){
          getLevel();
        }
      });
      watchEffect(() => {
        var formData = props.formData || {};
        if (!_lodash.isEmpty(formData)) {
          form.value = formData;
          // if(formData.is_can_add == 1 || formData.is_can_del == 1){
          //   form.value.manage = 1
          // }else{
          //   form.value.manage = 0
          // }
        } else {
          form.value = defForm;
        }
      });
      return {
        form,
        ...toRefs(state),
        ruleForm,
        onSubmit,
        typeSetup
      }
    }
  }
</script>
